export default {
  name: "id",
  in: "path",
  required: true,
  description: "Unique size chart identifier",
  schema: {
    type: "integer",
    example: 49
  }
};
